import snakecaseKeys from 'snakecase-keys';
import { InjectiveExchangeV2Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgSetDelegationTransferReceivers extends MsgBase {
    static fromJSON(params) {
        return new MsgSetDelegationTransferReceivers(params);
    }
    toProto() {
        const { params } = this;
        const message = InjectiveExchangeV2Tx.MsgSetDelegationTransferReceivers.create();
        message.sender = params.sender;
        message.receivers = params.receivers;
        return InjectiveExchangeV2Tx.MsgSetDelegationTransferReceivers.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.exchange.v2.MsgSetDelegationTransferReceivers',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'exchange/MsgSetDelegationTransferReceivers',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.exchange.v2.MsgSetDelegationTransferReceivers',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.exchange.v2.MsgSetDelegationTransferReceivers',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveExchangeV2Tx.MsgSetDelegationTransferReceivers.encode(this.toProto()).finish();
    }
}
